var React = require('react');

function Instagram (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"instagram","d":"M6.138.6A5.554,5.554,0,0,0,.6,6.138V13.89a5.554,5.554,0,0,0,5.538,5.538H13.89a5.554,5.554,0,0,0,5.538-5.538V6.138A5.554,5.554,0,0,0,13.89.6H6.138Zm0,1.661H13.89a3.883,3.883,0,0,1,3.876,3.876V13.89a3.883,3.883,0,0,1-3.876,3.876H6.138A3.883,3.883,0,0,1,2.261,13.89V6.138A3.883,3.883,0,0,1,6.138,2.261Zm8.939,1.9a.793.793,0,0,0-.791.791.791.791,0,0,0,1.582,0A.747.747,0,0,0,15.077,4.16Zm-5.063.712a5.142,5.142,0,1,0,5.142,5.142A5.132,5.132,0,0,0,10.014,4.872Zm0,1.74a3.4,3.4,0,1,1-3.4,3.4A3.377,3.377,0,0,1,10.014,6.612Z","transform":"translate(-0.6 -0.6)","fill":"#fff"}));
}

Instagram.defaultProps = {"viewBox":"0 0 18.828 18.828"};

module.exports = Instagram;

Instagram.default = Instagram;
